export const guideDetails = {
  'presale-deposit-return': {
    slug: 'presale-deposit-return',
    intro: '预售本身没有问题，问题出在「定金」被写成了不可退的条款，以及尾款价格在正式开卖时悄悄上调。下单前把这两件事确认清楚，基本就能避开八成争议。',
    riskNote: '涉及定金与尾款，一旦支付，退款往往需要平台介入，处理周期长。',
    sections: [
      {
        heading: '「定金」与「订金」不是一回事',
        paragraphs: [
          '很多商家在商品页写「预付定金立减」，但合同性质上写成「订金」时，通常可以协商退还；写成「定金」，则适用定金罚则——你违约不付尾款，商家有权不退还。付款前先看平台规则里写的是哪个词。',
          '如果页面没有明确说明，截图保存是必要的。发生争议时，先提交平台客服，再考虑向消费者组织反映，不要直接和商家在聊天框里吵。',
        ],
      },
      {
        heading: '警惕「先涨后降」的尾款',
        paragraphs: [
          '常见节奏是：预售期标出一个高「参考价」，正式开卖前把尾款价上调，再用优惠券「抹平」。把商品加入收藏并记录历史价格，就能看出真实波动。',
          '到手价应该以「尾款 + 定金 + 已用优惠」合计为准，而不是只看页面上那个被放大的折扣数字。',
        ],
      },
      {
        heading: '尾款期限与自动关闭',
        paragraphs: [
          '尾款通常有明确支付时间窗，逾期订单会自动关闭，定金按规则处理。设一个手机提醒，比事后申诉省事得多。',
          '如果商品在预售期内下架或改配置，及时截图页面，作为后续维权的依据。',
        ],
      },
    ],
    signals: ['页面只写「定金」不写退法', '尾款价明显高于历史最低价', '优惠券规则写得含糊可以随意解释', '客服回避「能不能退」这个问题'],
    checklist: ['付款前确认是「定金」还是「订金」', '记录并截图历史价格走势', '算清到手价而不是看折扣数字', '给尾款设一个支付提醒', '下单后保留完整聊天记录与页面截图'],
  },
  'bigpromo-coupon-traps': {
    slug: 'bigpromo-coupon-traps',
    intro: '大促的规则越复杂，越容易让人只盯着「省了多少」而忽略「本来该花多少」。这份清单帮你把优惠规则还原成真实价格。',
    riskNote: '多数属于体验层面的吃亏，但叠加分期后可能带来额外费用。',
    sections: [
      {
        heading: '先看历史价，再看折扣',
        paragraphs: [
          '把商品加入购物车观察两到三周，或使用平台自带的价格趋势功能，能有效识别「先涨后降」。折扣数字本身没有意义，价格曲线才有。',
        ],
      },
      {
        heading: '券的叠加顺序会改变到手价',
        paragraphs: [
          '平台券、店铺券、品类券往往不能自由叠加，顺序不同结果也不同。结算页的价格是唯一可信的答案，加入购物车反复试算比研究规则更实用。',
          '注意「跨店满减」的门槛是按原价还是券后价计算，这一点直接决定你要不要为了凑单多买东西。',
        ],
      },
      {
        heading: '别为凑单买不需要的东西',
        paragraphs: [
          '凑单的本质是用确定性支出换取不确定性折扣。为了省 30 元多买 200 元的闲置品，是最常见的隐身亏损。',
          '如果确实需要凑单，优先选择可退换、口碑稳定的日用品，而不是冲动型商品。',
        ],
      },
    ],
    signals: ['折扣款突然从收藏里消失又上架', '规则说明反复修改', '只能通过特定入口才看到真实价格', '客服说不清优惠是否叠加'],
    checklist: ['至少观察两周的历史价格', '以结算页到手价为准', '确认满减门槛的计算基数', '不为凑单购买非计划商品', '大促后回看是否真的省了钱'],
  },
  'skincare-marketing-words': {
    slug: 'skincare-marketing-words',
    intro: '护肤品的效果来自成分、浓度与配方，而不是来自形容词。识别几种高频营销话术，能帮你把注意力放回真正重要的信息上。',
    riskNote: '主要风险是花了钱却买不到对应效果，个别产品还可能引起不适。',
    sections: [
      {
        heading: '「一瓶抵十瓶」几乎不可验证',
        paragraphs: [
          '功效宣称需要有对应的检测依据。看到这类绝对化表述时，先找产品页里的功效评价资料或备案信息，找不到就当作参考而非承诺。',
        ],
      },
      {
        heading: '成分表靠前 ≠ 有效浓度',
        paragraphs: [
          '成分表按含量降序排列，但「靠前」对高浓度成分和低浓度原料的意义完全不同。判断功效要看核心成分是否排在前段，以及是否标注了浓度。',
          '很多「概念添加」把成分名字写进宣传，实际添加量却排在防腐剂之后，几乎没有实际作用。',
        ],
      },
      {
        heading: '先小样，再正装',
        paragraphs: [
          '皮肤耐受因人而异。对没试过的活性成分，先用小样或试用装观察一到两周，比直接买大瓶更稳妥，也能避免整套产品浪费。',
        ],
      },
    ],
    signals: ['使用绝对化功效表述', '宣称「医院同款」「药妆」', '成分表里核心成分排在很后面', '只讲感受不讲任何检测依据'],
    checklist: ['核对产品的功效宣称依据', '看核心成分的排序与浓度标注', '新成分先买小样并做耐受测试', '不迷信「网红同款」话术', '保留购买凭证便于售后'],
  },
  'daigou-skincare-signals': {
    slug: 'daigou-skincare-signals',
    intro: '代购与水货的核心风险不是「是不是真的」，而是出了问题之后无法追溯。价格、批号、票据这三样对不上，就要谨慎了。',
    riskNote: '一旦出现质量问题，缺少正规渠道与发票，维权会非常困难。',
    sections: [
      {
        heading: '价格过低是最早的红灯',
        paragraphs: [
          '如果价格明显低于品牌常见折扣区间，先别急着庆幸。低价背后可能是来源不明的库存，也可能是临期或拆封商品。先对比官方与主流渠道的价格带。',
        ],
      },
      {
        heading: '批号、日期与包装细节要对得上',
        paragraphs: [
          '正品的批号通常可以对应生产日期与产地信息，包装印刷、封口、喷码也应整齐一致。细节粗糙不一定是假货，但值得停下来多问一句。',
          '如果商家只发几张模糊的样张、拒绝提供完整实拍，最好不要下单。',
        ],
      },
      {
        heading: '售后路径要提前问清',
        paragraphs: [
          '买之前就问清楚：出现过敏或质量问题怎么办？能不能换？退货运费谁承担？把答复截图留存，比事后争论有效得多。',
        ],
      },
    ],
    signals: ['价格显著低于市场价', '批号无法对应生产信息', '只提供样张拒绝实拍', '售后只口头承诺不写进描述'],
    checklist: ['对比官方渠道价格带', '要求提供完整实拍与批号', '确认能开发票或购买凭证', '提前问清退换与运费责任', '保存全部沟通记录'],
  },
  'tradein-refurbished-new': {
    slug: 'tradein-refurbished-new',
    intro: '以旧换新和低价「新机」是翻新机最常见的外衣。到手后先查激活信息与电池健康，比看包装盒更接近真相。',
    riskNote: '金额较大，且翻新机往往已过保，问题暴露可能已错过退换期。',
    sections: [
      {
        heading: '激活日期是第一个证据',
        paragraphs: [
          '开机后到设置里查看保修状态与激活时间。如果激活日期早于你的收货日期，说明这台机器此前已被使用过。这是判断翻新最直接的方式。',
        ],
      },
      {
        heading: '电池循环与外观要一起看',
        paragraphs: [
          '查看电池循环次数与健康度，再对照机身、接口、屏幕的磨损痕迹。任何一个指标与实际使用时长不匹配，都值得追问。',
          '「仅拆封未激活」这类说法缺乏依据，不要作为放心购买的理由。',
        ],
      },
      {
        heading: '购买渠道决定保修的边界',
        paragraphs: [
          '非授权渠道的机器，官方保修可能不承认。下单前问清楚保修由谁承担、如何送修、期限多长，并写进订单备注或聊天记录。',
        ],
      },
    ],
    signals: ['价格明显低于官方到手价', '强调「仅拆封」「渠道机」', '不愿提供激活与保修信息', '保修责任含糊其辞'],
    checklist: ['收货后立即查询激活日期', '核对电池循环次数与健康度', '检查机身与接口磨损痕迹', '确认保修主体与期限', '发现问题第一时间申请退换'],
  },
  'extended-warranty-value': {
    slug: 'extended-warranty-value',
    intro: '延保不是智商税，也不是万能钥匙。值不值得买，取决于产品故障率、免责条款和上门成本这三件事。',
    riskNote: '大多是花小钱买心理安慰，注意别重复购买已有的服务。',
    sections: [
      {
        heading: '先看原厂保修还剩多久',
        paragraphs: [
          '延保通常从原厂保修结束后生效。如果已经买了含长期保修的机型，或产品本身故障率低，延保的边际价值就很有限。',
        ],
      },
      {
        heading: '免责范围比保期更关键',
        paragraphs: [
          '进水、摔损、耗材更换、人为损坏往往不在范围内。买之前把免责条款完整读一遍，很多人是在报修被拒时才发现自己买了个用不上的服务。',
        ],
      },
      {
        heading: '算一笔上门成本',
        paragraphs: [
          '小家电的维修上门费可能接近新机价格。对这类产品，与其买延保，不如把预算留给质量更稳的型号。',
        ],
      },
    ],
    signals: ['销售只强调「保多久」不提免责', '与原厂保修重复', '上门费需额外自付', '不同渠道延保互不承认'],
    checklist: ['确认原厂保修与延保的时间衔接', '逐条阅读免责范围', '估算上门与运费成本', '对比同价位更可靠的型号', '保留延保合同与凭证'],
  },
};